import * as React from 'react';
import { Box, Heading, Text } from 'wix-style-react';
function ReviewAppPageSuccessMessage(_a) {
    var t = _a.t;
    var successTitleText = t('review-app.success-message-title');
    var successSubTitleText = t('review-app.success-message-sub-title');
    return (React.createElement(Box, { direction: "vertical", align: "center", textAlign: "center", maxWidth: "450px", marginTop: "150px" },
        React.createElement(Box, null,
            React.createElement(Heading, { appearance: "H2" }, successTitleText)),
        React.createElement(Box, { marginTop: "12px" },
            React.createElement(Text, { secondary: true }, successSubTitleText))));
}
export { ReviewAppPageSuccessMessage };
//# sourceMappingURL=review-app-page-success-message.js.map